module.exports = __webpack_public_path__ + "img/sort／phone／Racing@2x.ff861f60.png";